import { render, staticRenderFns } from "./WallImageBlockSettings.vue?vue&type=template&id=097620a1"
import script from "./WallImageBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallImageBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports